import React, { useState, useEffect } from 'react';

import Title from './Title';
import Text from './Text';

import { t } from 'i18n';
import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/system';

// Keyframe animation for dot opacity
const pulseAnimation = keyframes`
  0%, 100% { opacity: 0.2; }
  50% { opacity: 1; }
`;

const StepContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

const DotsContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  width: '24px',
});

const Dot = styled('span')(({ delay }) => ({
  fontSize: '1rem',
  animation: `${pulseAnimation} 2s infinite`,
  animationDelay: `${delay}ms`,
}));

const BuildingStatus = () => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  
  const steps = [
    t('account:building:lookingUpEvents'),
    t('account:building:checkingMicLevels'),
    t('account:building:paintingProfile'),
    t('account:building:writingSetlist'),
    t('account:building:lastSoundcheck'),
    t('account:building:warmingUpCrowd'),
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStepIndex((prevIndex) => {
        if (prevIndex < steps.length - 1) {
          return prevIndex + 1;
        }
        clearInterval(timer);
        return prevIndex;
      });
    }, 6000);

    return () => clearInterval(timer);
  }, [steps.length]);

  return (
    <>
      <Title>
        {t('account:building:title')}
      </Title>
      <StepContainer>
        <Text>
          {steps[currentStepIndex]}
        </Text>
        <DotsContainer>
          <Dot delay={0}>.</Dot>
          <Dot delay={333}>.</Dot>
          <Dot delay={666}>.</Dot>
        </DotsContainer>
      </StepContainer>
    </>
  );
};

export default BuildingStatus;